import { WidgetWithData } from '@vyce/core/src/modules';
import { WidgetModuleProvider } from '@vyce/core/src/contexts';
import { WidgetWrapper, WidgetWrapperProps } from '@vyce/core/src/components/Dashboard/WidgetWrapper';
import { ChatUser, LocationAndTeamsFilterState, WidgetItem } from '@vyce/core/src/types';

import { useWidgetData } from './hooks';
import { useMemo } from 'react';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

interface Props {
  widget: WidgetItem;
  redirectUrl?: string;
  mainDashboardFilters?: LocationAndTeamsFilterState;
  customTeamId?: string;
}

export const WidgetModule = ({
  widget,
  redirectUrl,
  mainDashboardFilters,
  customTeamId,
  ...rest
}: Props & WidgetWrapperProps) => {
  const data = useWidgetData();
  const { user } = useTypedSelector(state => state);
  const chatCreator: ChatUser = {
    uid: user.uuid,
    name: `${user.first_name} ${user.last_name}`,
    email: user.email,
    phone: user.phone,
    avatarUrl: user.photo?.url,
  };

  const contextOptions = useMemo(
    () => ({
      ...data,
      widget,
      redirectUrl,
      mainDashboardFilters,
      customTeamId,
      onForbidden: rest.onForbidden,
    }),
    [data, mainDashboardFilters, widget, redirectUrl, customTeamId, rest.onForbidden]
  );

  return (
    <WidgetWrapper {...rest}>
      <WidgetModuleProvider value={contextOptions}>
        <WidgetWithData chatCreator={chatCreator} />
      </WidgetModuleProvider>
    </WidgetWrapper>
  );
};
